import { render, staticRenderFns } from "./braceletConfig.vue?vue&type=template&id=40767b87&scoped=true&"
import script from "./braceletConfig.vue?vue&type=script&lang=js&"
export * from "./braceletConfig.vue?vue&type=script&lang=js&"
import style0 from "./braceletConfig.vue?vue&type=style&index=0&id=40767b87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40767b87",
  null
  
)

export default component.exports